console.log('PHOTO DETECTOR V9 LOADED');

let imagePixelWidth = null;
let imagePixelHeight = null;

const MIN_PRINT_SIDE = 8;
const MAX_PRINT_SIDE = 60;

const EXCELLENT_PPI = 200;
const GOOD_PPI = 150;
const LOW_PPI = 120;

const CROP_TOLERANCE = 0.03;


// --------------------------------------------------
// FIND APO INPUT BY OPTION TEXT
// --------------------------------------------------

function findInputByOptionText(labelText) {

  const inputs = document.querySelectorAll(
    'input.mw-option__control[type="number"]'
  );

  for (const input of inputs) {

    const option = input.closest('.mw-option');

    if (!option) {
      continue;
    }

    const optionText = option.innerText
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    if (
      optionText.includes(
        labelText.toLowerCase()
      )
    ) {
      return input;
    }
  }

  return null;
}


// --------------------------------------------------
// WIDTH / HEIGHT INPUTS
// --------------------------------------------------

function getWidthInput() {
  return findInputByOptionText(
    'Print Width'
  );
}

function getHeightInput() {
  return findInputByOptionText(
    'Print Height'
  );
}


// --------------------------------------------------
// GET WIDTH OPTION WRAPPER
// --------------------------------------------------

function getWidthOption() {

  const input = getWidthInput();

  if (!input) {
    return null;
  }

  return input.closest('.mw-option');
}


// --------------------------------------------------
// INFO BOX
// --------------------------------------------------

function createInfoBox() {

  let box = document.getElementById(
    'photo-resolution-info'
  );

  if (box) {
    return box;
  }

  const widthOption =
    getWidthOption();

  if (!widthOption) {

    console.log(
      'PRINT WIDTH OPTION NOT FOUND'
    );

    return null;
  }

  box =
    document.createElement('div');

  box.id =
    'photo-resolution-info';

  box.style.padding =
    '16px 18px';

  box.style.marginTop =
    '10px';

  box.style.marginBottom =
    '22px';

  box.style.border =
    '1px solid #d6d6d6';

  box.style.borderRadius =
    '6px';

  box.style.background =
    '#fafafa';

  box.style.fontSize =
    '14px';

  box.style.lineHeight =
    '1.5';

  widthOption.parentNode.insertBefore(
    box,
    widthOption
  );

  return box;
}


// --------------------------------------------------
// IMAGE RATIO
// --------------------------------------------------

function getImageRatio() {

  const longSide =
    Math.max(
      imagePixelWidth,
      imagePixelHeight
    );

  const shortSide =
    Math.min(
      imagePixelWidth,
      imagePixelHeight
    );

  return longSide / shortSide;
}


// --------------------------------------------------
// COMMON PRINT SIZES
// --------------------------------------------------

const COMMON_PRINT_SIZES = [

  [8, 8],
  [8, 10],
  [8, 12],

  [9, 12],

  [10, 10],
  [10, 12],
  [10, 13],
  [10, 14],
  [10, 15],

  [11, 11],
  [11, 14],

  [12, 12],
  [12, 15],
  [12, 16],
  [12, 18],

  [14, 14],
  [14, 18],
  [14, 21],

  [15, 15],
  [15, 20],

  [16, 16],
  [16, 20],
  [16, 21],
  [16, 24],

  [18, 18],
  [18, 24],
  [18, 27],

  [20, 20],
  [20, 25],
  [20, 27],
  [20, 30],

  [22, 22],
  [22, 28],
  [22, 33],

  [24, 24],
  [24, 30],
  [24, 32],
  [24, 36],

  [25, 25],
  [25, 30],

  [26, 26],
  [26, 32],
  [26, 39],

  [28, 28],
  [28, 35],
  [28, 37],
  [28, 42],

  [30, 30],
  [30, 38],
  [30, 40],
  [30, 45],

  [32, 32],
  [32, 40],
  [32, 43],
  [32, 48],

  [34, 34],
  [34, 43],
  [34, 45],
  [34, 51],

  [36, 36],
  [36, 45],
  [36, 48],
  [36, 54],

  [38, 38],
  [38, 48],
  [38, 51],
  [38, 57],

  [40, 40],
  [40, 50],
  [40, 53],
  [40, 60],

  [42, 42],
  [44, 44],
  [46, 46],
  [48, 48],
  [50, 50],
  [52, 52],
  [54, 54],
  [56, 56],
  [58, 58],
  [60, 60]

];


// --------------------------------------------------
// CALCULATE PPI
// --------------------------------------------------

function calculatePPI(
  printWidth,
  printHeight
) {

  const normalPPI =
    Math.min(
      imagePixelWidth / printWidth,
      imagePixelHeight / printHeight
    );

  const rotatedPPI =
    Math.min(
      imagePixelHeight / printWidth,
      imagePixelWidth / printHeight
    );

  return Math.max(
    normalPPI,
    rotatedPPI
  );
}


// --------------------------------------------------
// RATIO DIFFERENCE
// --------------------------------------------------

function getRatioDifference(
  printWidth,
  printHeight
) {

  const imageRatio =
    getImageRatio();

  const printRatio =
    Math.max(
      printWidth,
      printHeight
    )
    /
    Math.min(
      printWidth,
      printHeight
    );

  return (
    Math.abs(
      imageRatio - printRatio
    )
    /
    imageRatio
  );
}


// --------------------------------------------------
// RECOMMENDED SIZES
// --------------------------------------------------

function getRecommendedSizes() {

  const recommendations = [];

  COMMON_PRINT_SIZES.forEach(
    function(size) {

      const width =
        size[0];

      const height =
        size[1];

      if (
        width < MIN_PRINT_SIDE ||
        height < MIN_PRINT_SIDE
      ) {
        return;
      }

      if (
        width > MAX_PRINT_SIDE ||
        height > MAX_PRINT_SIDE
      ) {
        return;
      }

      const ratioDifference =
        getRatioDifference(
          width,
          height
        );

      if (
        ratioDifference >
        CROP_TOLERANCE
      ) {
        return;
      }

      const ppi =
        calculatePPI(
          width,
          height
        );

      if (
        ppi < GOOD_PPI
      ) {
        return;
      }

      recommendations.push({
        width: width,
        height: height,
        ppi: Math.round(ppi)
      });

    }
  );

  recommendations.sort(
    function(a, b) {

      return (
        (a.width * a.height) -
        (b.width * b.height)
      );

    }
  );

  return recommendations;
}


// --------------------------------------------------
// SIZE BUTTON
// --------------------------------------------------

function createSizeButton(size) {

  let width =
    size.width;

  let height =
    size.height;


  if (
    imagePixelWidth >
    imagePixelHeight
  ) {

    width =
      Math.max(
        size.width,
        size.height
      );

    height =
      Math.min(
        size.width,
        size.height
      );

  }

  else if (
    imagePixelHeight >
    imagePixelWidth
  ) {

    width =
      Math.min(
        size.width,
        size.height
      );

    height =
      Math.max(
        size.width,
        size.height
      );

  }


  const button =
    document.createElement('button');

  button.type =
    'button';

  button.textContent =
    `${width}" × ${height}"`;

  button.style.padding =
    '7px 11px';

  button.style.margin =
    '4px 5px 4px 0';

  button.style.border =
    '1px solid #bbb';

  button.style.borderRadius =
    '4px';

  button.style.background =
    '#fff';

  button.style.cursor =
    'pointer';

  button.style.fontSize =
    '13px';


  button.addEventListener(
    'click',
    function() {

      const widthInput =
        getWidthInput();

      const heightInput =
        getHeightInput();

      if (
        !widthInput ||
        !heightInput
      ) {
        return;
      }

      widthInput.value =
        width;

      heightInput.value =
        height;

      widthInput.dispatchEvent(
        new Event(
          'input',
          { bubbles: true }
        )
      );

      widthInput.dispatchEvent(
        new Event(
          'change',
          { bubbles: true }
        )
      );

      heightInput.dispatchEvent(
        new Event(
          'input',
          { bubbles: true }
        )
      );

      heightInput.dispatchEvent(
        new Event(
          'change',
          { bubbles: true }
        )
      );

      updateInfoBox();

    }
  );

  return button;
}


// --------------------------------------------------
// UPDATE BOX
// --------------------------------------------------

function updateInfoBox() {

  if (
    !imagePixelWidth ||
    !imagePixelHeight
  ) {
    return;
  }

  const box =
    createInfoBox();

  if (!box) {
    return;
  }

  const widthInput =
    getWidthInput();

  const heightInput =
    getHeightInput();

  const printWidth =
    widthInput
      ? parseFloat(
          widthInput.value
        )
      : NaN;

  const printHeight =
    heightInput
      ? parseFloat(
          heightInput.value
        )
      : NaN;

  const recommendedSizes =
    getRecommendedSizes();


  let html = `

    <div>

      <div style="
        font-weight:600;
        font-size:15px;
        margin-bottom:8px;
      ">
        Recommended Print Sizes
      </div>

      <div id="recommended-size-buttons"></div>

  `;


  if (
    recommendedSizes.length === 0
  ) {

    html += `

      <div>
        ⚠ This image may not have enough
        resolution for an 8" or larger print.
      </div>

    `;

  }

  html += `</div>`;


  if (
    !isNaN(printWidth) &&
    !isNaN(printHeight) &&
    printWidth >= MIN_PRINT_SIDE &&
    printHeight >= MIN_PRINT_SIDE
  ) {

    const ppi =
      calculatePPI(
        printWidth,
        printHeight
      );

    const ratioDifference =
      getRatioDifference(
        printWidth,
        printHeight
      );

    let qualityTitle;
    let qualityMessage;


    if (
      ppi >= EXCELLENT_PPI
    ) {

      qualityTitle =
        '✓ Excellent print quality';

      qualityMessage =
        'Your image has plenty of resolution for this size.';

    }

    else if (
      ppi >= GOOD_PPI
    ) {

      qualityTitle =
        '✓ Good print quality';

      qualityMessage =
        'Your image should print well at this size.';

    }

    else if (
      ppi >= LOW_PPI
    ) {

      qualityTitle =
        '⚠ Lower print quality';

      qualityMessage =
        'Your image may appear slightly soft at this size.';

    }

    else {

      qualityTitle =
        '⚠ Resolution too low';

      qualityMessage =
        'We recommend choosing a smaller print size.';

    }


    html += `

      <div style="
        border-top:1px solid #ddd;
        margin-top:14px;
        padding-top:12px;
      ">

        <div style="
          font-weight:600;
          font-size:15px;
        ">
          ${qualityTitle}
        </div>

        <div style="
          margin-top:3px;
        ">
          ${qualityMessage}
        </div>

        <div style="
          color:#666;
          margin-top:3px;
        ">
          About
          ${Math.round(ppi)}
          PPI at
          ${printWidth}" × ${printHeight}"
        </div>

    `;


    if (
      ratioDifference >
      CROP_TOLERANCE
    ) {

      html += `

        <div style="
          margin-top:12px;
          padding-top:10px;
          border-top:1px solid #eee;
        ">

          ⚠ <strong>
            Significant cropping required
          </strong>

          <div style="
            color:#666;
            margin-top:3px;
          ">
            This size has a noticeably different
            shape than your uploaded image.
          </div>

        </div>

      `;

    }

    else if (
      ratioDifference > 0.005
    ) {

      html += `

        <div style="
          margin-top:10px;
          color:#666;
        ">
          Minor cropping may be used to fit this size.
        </div>

      `;

    }

    html += `</div>`;
  }


  box.innerHTML =
    html;


  const buttonContainer =
    document.getElementById(
      'recommended-size-buttons'
    );


  if (buttonContainer) {

    recommendedSizes.forEach(
      function(size) {

        buttonContainer.appendChild(
          createSizeButton(size)
        );

      }
    );

  }
}


// --------------------------------------------------
// UPLOAD-LIFT
// --------------------------------------------------

document.addEventListener(
  'change',
  function(event) {

    const input =
      event.target;

    if (
      !input ||
      input.type !== 'file' ||
      !String(input.className)
        .includes(
          'filepond--browser'
        )
    ) {
      return;
    }

    const file =
      input.files &&
      input.files[0];

    if (!file) {
      return;
    }

    if (
      !file.type.startsWith('image/')
    ) {
      return;
    }

    console.log(
      'UPLOAD DETECTED:',
      file.name
    );

    const image =
      new Image();

    const objectURL =
      URL.createObjectURL(file);


    image.onload =
      function() {

        imagePixelWidth =
          image.naturalWidth;

        imagePixelHeight =
          image.naturalHeight;

        console.log(
          'IMAGE DIMENSIONS:',
          imagePixelWidth,
          'x',
          imagePixelHeight
        );

        console.log(
          'WIDTH INPUT:',
          getWidthInput()
        );

        console.log(
          'HEIGHT INPUT:',
          getHeightInput()
        );

        URL.revokeObjectURL(
          objectURL
        );

        updateInfoBox();

      };


    image.onerror =
      function() {

        console.log(
          'IMAGE READ ERROR'
        );

        URL.revokeObjectURL(
          objectURL
        );

      };


    image.src =
      objectURL;

  },
  true
);


// --------------------------------------------------
// WATCH APO WIDTH / HEIGHT
// --------------------------------------------------

document.addEventListener(
  'input',
  function(event) {

    if (
      event.target === getWidthInput() ||
      event.target === getHeightInput()
    ) {

      updateInfoBox();

    }

  }
);

// --------------------------------------------------
// PRINT ONLY - VISUALLY HIDE FRAMING OPTIONS
// --------------------------------------------------

let nwaIsPrintOnly = false;


// --------------------------------------------------
// NORMALIZE TEXT
// --------------------------------------------------

function nwaNormalizeText(text) {

  return String(text || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

}


// --------------------------------------------------
// SHOULD THIS APO OPTION BE HIDDEN?
// --------------------------------------------------

function nwaShouldHideOption(option) {

  if (!option) {
    return false;
  }

  const text =
    nwaNormalizeText(
      option.innerText
    );


  // NEVER hide the Framed Print / Print Only selector itself
  if (
    text.includes('print only') ||
    text.includes('framed print')
  ) {
    return false;
  }


  // Framing-related APO fields
  const hideKeywords = [
    'frame',
    'mat',
    'glazing',
    'glass',
    'hardware',
    'color'
  ];


  return hideKeywords.some(
    function(keyword) {

      return text.includes(keyword);

    }
  );

}


// --------------------------------------------------
// UPDATE VISIBILITY
// --------------------------------------------------

function nwaUpdatePrintOnlyVisibility() {

  const options =
    document.querySelectorAll(
      '.mw-option'
    );


  options.forEach(
    function(option) {

      if (
        !nwaShouldHideOption(option)
      ) {
        return;
      }


      if (
        nwaIsPrintOnly
      ) {

        option.style.setProperty(
          'display',
          'none',
          'important'
        );

      }

      else {

        option.style.removeProperty(
          'display'
        );

      }

    }
  );


  console.log(
    'NWA PRODUCT TYPE:',
    nwaIsPrintOnly
      ? 'PRINT ONLY'
      : 'FRAMED PRINT'
  );

}


// --------------------------------------------------
// DETECT CLICK ON PRINT ONLY / FRAMED PRINT
// --------------------------------------------------

document.addEventListener(
  'click',
  function(event) {

    let element =
      event.target;


    // Look at the clicked element and a few parents
    // because APO may put the text inside a span/div.
    for (
      let i = 0;
      i < 5 && element;
      i++
    ) {

      const text =
        nwaNormalizeText(
          element.innerText ||
          element.textContent
        );


      if (
        text === 'print only' ||
        (
          text.includes('print only') &&
          text.length < 100
        )
      ) {

        nwaIsPrintOnly = true;

        console.log(
          'NWA CLICK DETECTED: PRINT ONLY'
        );

        setTimeout(
          nwaUpdatePrintOnlyVisibility,
          50
        );

        setTimeout(
          nwaUpdatePrintOnlyVisibility,
          250
        );

        return;
      }


      if (
        text === 'framed print' ||
        (
          text.includes('framed print') &&
          text.length < 100
        )
      ) {

        nwaIsPrintOnly = false;

        console.log(
          'NWA CLICK DETECTED: FRAMED PRINT'
        );

        setTimeout(
          nwaUpdatePrintOnlyVisibility,
          50
        );

        setTimeout(
          nwaUpdatePrintOnlyVisibility,
          250
        );

        return;
      }


      element =
        element.parentElement;

    }

  },
  true
);


// --------------------------------------------------
// ALSO DETECT NORMAL INPUT CHANGES
// --------------------------------------------------

document.addEventListener(
  'change',
  function(event) {

    const target =
      event.target;

    if (!target) {
      return;
    }


    let text =
      nwaNormalizeText(
        target.value
      );


    if (target.id) {

      const label =
        document.querySelector(
          `label[for="${CSS.escape(target.id)}"]`
        );

      if (label) {

        text +=
          ' ' +
          nwaNormalizeText(
            label.innerText
          );

      }

    }


    if (
      text.includes('print only')
    ) {

      nwaIsPrintOnly = true;

      nwaUpdatePrintOnlyVisibility();

    }

    else if (
      text.includes('framed print')
    ) {

      nwaIsPrintOnly = false;

      nwaUpdatePrintOnlyVisibility();

    }

  },
  true
);


// --------------------------------------------------
// WATCH APO RE-RENDERS
// --------------------------------------------------

const nwaPrintObserver =
  new MutationObserver(
    function() {

      nwaUpdatePrintOnlyVisibility();

    }
  );


nwaPrintObserver.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);


// --------------------------------------------------
// INITIAL LOAD
// --------------------------------------------------

setTimeout(
  nwaUpdatePrintOnlyVisibility,
  1000
);